import { AlertTriangle } from 'lucide-react'
import { Badge } from './badge'

interface ObligationStatusBadgeProps {
  readonly status: 'PAID' | 'CANCELED' | 'PENDING' | string
  /** Calculado em runtime: status=PENDING AND dueDate < hoje. */
  readonly isOverdue?: boolean
}

export function ObligationStatusBadge({ status, isOverdue }: ObligationStatusBadgeProps) {
  if (status === 'PAID') {
    return <Badge tone="success">Quitada</Badge>
  }
  if (status === 'CANCELED') {
    return <Badge tone="neutral">Cancelada</Badge>
  }
  if (isOverdue) {
    return (
      <Badge tone="danger" icon={<AlertTriangle size={11} />}>
        Vencida
      </Badge>
    )
  }
  return <Badge tone="warning">Em aberto</Badge>
}
